import { createI18n } from 'vue-i18n';

import feedbackAm from '@/modules/feedback/locales/am';
import feedbackAr from '@/modules/feedback/locales/ar';
import feedbackBg from '@/modules/feedback/locales/bg';
import feedbackCs from '@/modules/feedback/locales/cs';
import feedbackDa from '@/modules/feedback/locales/da';
import feedbackDe from '@/modules/feedback/locales/de';
import feedbackEn from '@/modules/feedback/locales/en';
import feedbackEs from '@/modules/feedback/locales/es';
import feedbackEt from '@/modules/feedback/locales/et';
import feedbackFi from '@/modules/feedback/locales/fi';
import feedbackFr from '@/modules/feedback/locales/fr';
import feedbackId from '@/modules/feedback/locales/id';
import feedbackIt from '@/modules/feedback/locales/it';
import feedbackJa from '@/modules/feedback/locales/ja';
import feedbackKo from '@/modules/feedback/locales/ko';
import feedbackMs from '@/modules/feedback/locales/ms';
import feedbackNb from '@/modules/feedback/locales/nb';
import feedbackNl from '@/modules/feedback/locales/nl';
import feedbackNo from '@/modules/feedback/locales/no';
import feedbackPl from '@/modules/feedback/locales/pl';
import feedbackPt from '@/modules/feedback/locales/pt';
import feedbackRo from '@/modules/feedback/locales/ro';
import feedbackRu from '@/modules/feedback/locales/ru';
import feedbackSv from '@/modules/feedback/locales/sv';
import feedbackSw from '@/modules/feedback/locales/sw';
import feedbackTh from '@/modules/feedback/locales/th';
import feedbackTr from '@/modules/feedback/locales/tr';
import feedbackUk from '@/modules/feedback/locales/uk';
import feedbackVi from '@/modules/feedback/locales/vi';
import feedbackZh from '@/modules/feedback/locales/zh';

export const SUPPORTED_LOCALES = [
  'am',
  'ar',
  'bg',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'nb',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sv',
  'sw',
  'th',
  'tr',
  'uk',
  'vi',
  'zh',
] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'en';

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    am: { feedback: feedbackAm },
    ar: { feedback: feedbackAr },
    bg: { feedback: feedbackBg },
    cs: { feedback: feedbackCs },
    da: { feedback: feedbackDa },
    de: { feedback: feedbackDe },
    en: { feedback: feedbackEn },
    es: { feedback: feedbackEs },
    et: { feedback: feedbackEt },
    fi: { feedback: feedbackFi },
    fr: { feedback: feedbackFr },
    id: { feedback: feedbackId },
    it: { feedback: feedbackIt },
    ja: { feedback: feedbackJa },
    ko: { feedback: feedbackKo },
    ms: { feedback: feedbackMs },
    nb: { feedback: feedbackNb },
    nl: { feedback: feedbackNl },
    no: { feedback: feedbackNo },
    pl: { feedback: feedbackPl },
    pt: { feedback: feedbackPt },
    ro: { feedback: feedbackRo },
    ru: { feedback: feedbackRu },
    sv: { feedback: feedbackSv },
    sw: { feedback: feedbackSw },
    th: { feedback: feedbackTh },
    tr: { feedback: feedbackTr },
    uk: { feedback: feedbackUk },
    vi: { feedback: feedbackVi },
    zh: { feedback: feedbackZh },
  },
});

export default i18n;
